// extracted by mini-css-extract-plugin
export default {"container":"MM-z","error":"NM-z","disabled":"OM-z","submit":"PM-z","option":"QM-z","success":"RM-z","failure":"SM-z"};